import * as React from 'react';

import { type SuggestionAction } from 'bundles/ai-coach-platform/components/patterns/suggestions/types';

type CoachSuggestionsState = {
  expandedId: string | null;
  setExpandedId: (id: string) => void;
  getIndex: (id: string) => number;
  updateSuggestionRef: (id: string, ref: HTMLDivElement | null) => void;
  onAction: (id: string, action: SuggestionAction) => Promise<void> | void;
  onDisclosureToggle: (id: string, expanded: boolean) => void;
};

export const CoachSuggestionsContext = React.createContext<CoachSuggestionsState>({
  expandedId: null,
  setExpandedId: () => undefined,
  getIndex: () => -1,
  updateSuggestionRef: () => undefined,
  onAction: () => undefined,
  onDisclosureToggle: () => undefined,
});

export const useCoachSuggestionsContext = () => React.useContext(CoachSuggestionsContext);
